import React from 'react';

const ButtonWithLoading = ({
  children,
  disabled = false,
  loading = false,
  className = '',
  style, 
  onClick,
  type = 'button',
}) => {
  return (
    <button
      className={className}
      style={style}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
    >
      {loading ? (
        <div className="spinner-border-wrapper">
          <div className="spinner-border" />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default ButtonWithLoading;
